module.exports = vendors_tr_cafa1cdcf7449f457c85;